/**
 * @file This file is used to initialize the application.
 */

init()

function init() {
    $(document).ready(function () { setupGlobal(); });
}

// Required modules
$(function () {
    uploader.init();
});

// Setup functions
function setupGlobal() {
    addClickByClass("#main-menu-toggle", function (event) {
        $("#main-menu-toggle").toggleClass("open");
        $("#main-menu-mobile").slideToggle(200);
    });
    addClickByClass("#main-menu-close", function (event) {
        $("#main-menu-toggle").removeClass("open");
        $("#main-menu-mobile").slideToggle(200);
    });

    $('.open-submenu').click(function (e) {
        e.preventDefault();
        $(this).siblings('.submenu').slideToggle(200);
        $('.submenu').not($(this).siblings('.submenu')).slideUp(200);
    });
}